(() => {
  const initialize = (root) => {
    if (root.dataset.cbLibraryReady === 'true') return;
    const dialog = root.querySelector('[data-cb-leather-dialog]');
    const stage = root.querySelector('[data-cb-dialog-stage]');
    const title = root.querySelector('[data-cb-dialog-title]');
    const close = root.querySelector('[data-cb-dialog-close]');
    if (!dialog || !stage || !title || !close || typeof dialog.showModal !== 'function') return;
    root.dataset.cbLibraryReady = 'true';
    let trigger = null;
    let previousOverflow = '';
    const clearMedia = () => {
      stage.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.removeAttribute('src');
        video.load();
      });
      stage.querySelectorAll('img').forEach((image) => image.removeAttribute('src'));
      stage.replaceChildren();
    };
    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[data-cb-media]');
      if (!link || !root.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const type = link.dataset.cbMedia;
      if (type !== 'image' && type !== 'video') return;
      const url = new URL(link.href, window.location.href);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
      event.preventDefault();
      clearMedia();
      trigger = link;
      title.textContent = link.dataset.title || link.textContent.trim();
      const media = document.createElement(type === 'video' ? 'video' : 'img');
      if (type === 'video') {
        media.controls = true;
        media.preload = 'none';
        media.playsInline = true;
        media.setAttribute('aria-label', link.dataset.alt || title.textContent);
        const thumbnail = link.querySelector('img');
        if (thumbnail) media.poster = thumbnail.currentSrc || thumbnail.src;
      } else {
        media.alt = link.dataset.alt || title.textContent;
        media.decoding = 'async';
      }
      media.src = url.href;
      stage.append(media);
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      close.focus({ preventScroll: true });
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      clearMedia();
      document.documentElement.style.overflow = previousOverflow;
      if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
      trigger = null;
    });
  };
  const initializeAll = () => document.querySelectorAll('[data-cb-leather-library]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
